export default "__VITE_ASSET__BPvIhtzZ__"